import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, Link } from 'react-router-dom';

const IndustrySidebar = ({ caseStudies }) => {
    const { t } = useTranslation();
    const { lang } = useParams();

    return (
        <div className="item-contact_info">
            <div className="orbx-item--inner">
                <div className="orbx-item--top">
                    <h3 className="orbx-item--title">{t('common.caseStudies')}</h3>
                    <div className="d-flex flex-column gap-2 pt-20">
                        {caseStudies.map((cs, index) => (
                            <Link
                                key={index}
                                to={`/${lang}/portfolio/${cs.link}`}
                                className="d-flex align-items-center p-3"
                                style={{
                                    background: 'rgba(108, 92, 231, 0.1)',
                                    border: '1px solid rgba(108, 92, 231, 0.2)',
                                    borderRadius: '12px',
                                    textDecoration: 'none',
                                    transition: 'all 0.3s'
                                }}
                                onMouseEnter={e => { e.currentTarget.style.borderColor = '#6c5ce7'; e.currentTarget.style.background = 'rgba(108, 92, 231, 0.2)'; }}
                                onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(108, 92, 231, 0.2)'; e.currentTarget.style.background = 'rgba(108, 92, 231, 0.1)'; }}
                            >
                                <i className="fas fa-external-link-alt text-primary me-3"></i>
                                <span className="text-white">{cs.name}</span>
                            </Link>
                        ))}
                    </div>
                    <Link to={`/${lang}/portfolio`} className="orbx-btn-outline w-100 mt-3 text-center" style={{ display: 'block', textDecoration: 'none' }}>
                        {t('navigation.portfolio')} <i className="fas fa-arrow-right"></i>
                    </Link>
                </div>
                <hr className="breack-line" />
                <div className="mt-20">
                    <Link to={`/${lang}/contact`} className="orbx-btn w-100 text-center">
                        {t('common.contactUs')} <i className="fas fa-arrow-right"></i>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default IndustrySidebar;
